import { UpdateUnitNameLaravelRequest } from '../models/update-unit-name.model';

import { UpdateUnitNameRequest } from '../models/update-unit-name.model';

export function adaptToLaravelRequestUpdateUnitName(
  request: UpdateUnitNameRequest
): UpdateUnitNameLaravelRequest {
  return {
    body: {
      tracker_imei: request.unitImei,
      name: request.newName,
    },
  };
}
